import { Divider } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { IoCheckmarkDoneSharp } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { formatDate } from '../../common/utils'
import ReactDOM from 'react-dom'

import {
  deleteTransaction,
  getMyScansReport,
  updateCategory,
  updateQuantity,
} from '../../services/transactions'
import './todaysReport.css'
import moment from 'moment'

const Row = ({ item, index, setRecords }) => {
  const [quantity, setQuantity] = useState(0)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const timeoutIdRef = useRef(null)

  const sanitizeValue = (value) => {
    if (typeof value === 'string') {
      let sanitizedValue = value.replace(/\t/g, ' ').replace(/\r/g, '')
      sanitizedValue = sanitizedValue.replace(/[^a-zA-Z0-9 ]/g, '')
      return sanitizedValue
    }
    return value
  }

  const calculateCategories = (date, lrDate, existingCategory) => {

      if (date) {
        const expiryDateMoment = moment(date, 'YYYY-MM-DD').startOf('month')
      const currentDateMoment = lrDate
        ? moment(lrDate, 'YYYY-MM-DD').startOf('month')
        : moment().startOf('month')     
        const fourMonthsFromNow = currentDateMoment.clone().add(4, 'months')

        if (
          expiryDateMoment.isBefore(currentDateMoment) ||
          expiryDateMoment.isSame(currentDateMoment, 'month')
        ) {
          return 'Expiry' 
        } else if (expiryDateMoment.isBefore(fourMonthsFromNow)) {
          return 'Near Expiry'
        }
       else {
        return 'Damage'
      }
    }
    return ""
  }

  useEffect(() => {
    setQuantity(item['quantity'])
    const existingCat = item['category']
    const calculatedCategory = calculateCategories(
      item?.product?.EXPIRYDATE ?? '',
      item?.lrDate ?? '',
      existingCat
    )

    if (!existingCat || existingCat !== calculatedCategory) {
      setSelectedCategory(calculatedCategory)
      // onUpdateCategory(calculatedCategory)
    } else {
      setSelectedCategory(existingCat)
    }
  }, [item])

  const onDeleteTransaction = async () => {
    const response = await deleteTransaction(item['_id'])
    if (response['status'] == 'success') {
      toast.success('successfully deleted transaction')
      setRecords((prev) => prev?.filter((r) => r._id !== item['_id']))
    } else {
      toast.error(response['error'])
    }
  }

  const updateQuantityWithDebounce = (value) => {
    const debounceDelay = 500

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current)
    }

    timeoutIdRef.current = setTimeout(() => {
      onUpdateQuantity(value)
    }, debounceDelay)
  }

  const onUpdateQuantity = async (value) => {
    console.log(`updating quantities`)
    const response = await updateQuantity({
      quantity: value === '' ? '1' : value,
      transactionId: item['_id'],
      platform: `${item.platform} - Quantity`, 
    })
    if (response['status'] == 'success') {
      toast.success('successfully updated quantities')
    } else {
      toast.error(response['error'])
    }
  }

  const onUpdateCategory = async (category) => {
    console.log(`updating Category`)
    const response = await updateCategory({
      category,
      transactionId: item['_id'],
      platform: `${item.platform} - Category`, 
    })
    if (response['status'] == 'success') {
      toast.success('successfully updated Category')
    } else {
      toast.error(response['error'])
    }
  }

  console.log('category', selectedCategory)

  return (
    <tr key={index}>
      <td>{item?.category === 'TOTAL QTY' ? '' : index + 1}</td>
      <td>{item?.type || ''}</td>
      <td>{item?.associatedWith || ''}</td>
      <td>{sanitizeValue(item?.product?.SKU || '')}</td>
      <td>{sanitizeValue(item?.product?.BATCHNUMBER || '')}</td>
      <td>{sanitizeValue(item?.product?.MRP || '')}</td>
      <td>{formatDate(item?.product?.EXPIRYDATE)}</td>
      <td>{formatDate(item?.product?.MFG_DATE)}</td>
      <td>{item?.product?.optional2 || ''}</td>

      {item?.category === 'TOTAL QTY' ? (
        <td style={{ fontWeight: 'bold', textAlign: 'center' }}>TOTAL QTY</td>
      ) : (
        <td style={{ width: 200 }}>
          <div className="input-group mb-3">
            <select
              className="form-control"
              value={selectedCategory || ''}
              onChange={(e) => {
                const value = e.target.value
                onUpdateCategory(value)
                setSelectedCategory(value)
              }}
            >
              <option value=""></option>
              <option value="Expiry">Expiry</option>
              <option value="Near Expiry">Near Expiry</option>
              <option value="Damage">Damage</option>
            </select>
          </div>
        </td>
      )}

      {item?.category === 'TOTAL QTY' ? (
        <td style={{ fontWeight: 'bold', textAlign: 'center' }}>
          {item?.quantity ?? ''}
        </td>
      ) : (
        <td style={{ width: 150 }}>
          <div className="input-group mb-3">
            <input
              style={{ textAlign: 'center' }}
              min={1}
              type="number"
              className="form-control"
              onChange={(e) => {
                const value = e.target.value
                setQuantity(value)
                updateQuantityWithDebounce(value)
              }}
              value={quantity}
            />
          </div>
        </td>
      )}




      <td>
        {item?.category === 'TOTAL QTY' ? (
          ''
        ) : (
          <button
            onClick={onDeleteTransaction}
            className="btn btn-sm btn-danger"
          >
            delete
          </button>
        )}
      </td>
    </tr>
  )
}

const TodaysReport = () => {
  const prevCountRef = useRef(0)

  const count = useSelector((state) => state.scanResult.count)

  useEffect(() => {
    loadTodaysReport()
  }, [])

  useEffect(() => {
    loadTodaysReport()
  }, [count])




  const [records, setRecords] = useState([])
  const [shownPopups, setShownPopups] = useState(new Set())
  const [showTick, setShowTick] = useState(false)
  const [division, setDivision] = useState('')
  const loadTodaysReport = async () => {
    const response = await getMyScansReport()

    if (response['status'] === 'success') {
      const data = response.data || []
      const newLength = data.length
      const prevLength = prevCountRef.current
      const firstItem = data[0]
      const optional4 = String(firstItem?.optional4 || '').toLowerCase()

      prevCountRef.current = newLength

      setDivision(firstItem?.product?.optional2 || '')
      setRecords(data)

      if (
        (newLength > prevLength &&
          [
            'Auto',
            'Auto - Confirm',
            'Manual',
            'Auto - Quantity',
            'Auto - Category',
            'Auto - Confirm - Quantity',
            'Auto - Confirm - Category',
            'Manual - Quantity',
            'Manual - Category',
          ].includes(firstItem?.platform) &&
          prevLength > 0) ||
        (newLength === 1 &&
          [
            'Auto',
            'Auto - Confirm',
            'Manual',
            'Auto - Quantity',
            'Auto - Category',
            'Auto - Confirm - Quantity',
            'Auto - Confirm - Category',
            'Manual - Quantity',
            'Manual - Category',
          ].includes(firstItem?.platform) &&
          prevLength === 0)
      ) {
        setShowTick(true)
        setTimeout(() => setShowTick(false), 500)

        // setTimeout(async () => {
        //   if (optional4 !== 'true') {
        //     const expiry = firstItem.product?.EXPIRYDATE
        //     if (expiry) {
        //       const expiryDateMoment = moment(expiry, 'YYYY-MM-DD').startOf(
        //         'month'
        //       )
        //       const currentDateMoment = moment().startOf('month')
        //       const diffInMonths = expiryDateMoment.diff(
        //         currentDateMoment,
        //         'months'
        //       )

              // let selected = null
              // if (diffInMonths >= 2 && diffInMonths <= 5) {
              //   selected = await showCategoryPopup(['Expiry', 'Sellable'])
              // } else if (diffInMonths >= 6) {
              //   selected = await showCategoryPopup(['Damage', 'Sellable'])
              // }

              // if (selected) {
              //   const updateResponse = await updateCategory({
              //     category: selected,
              //     transactionId: firstItem['_id'],
              //     platform: firstItem?.platform, // use correct source
              //   })

              //   if (updateResponse.status === 'success') {
              //     toast.success(`Category updated to "${selected}"`)
              //     setRecords((prev) =>
              //       prev.map((row, i) =>
              //         i === 0 ? { ...row, category: selected } : row
              //       )
              //     )
              //   } else {
              //     toast.error(updateResponse.error)
              //   }
              // }
        //     }
        //   }
        // }, 300)
      }
    } else {
      toast.error(response['error'])
    }
  }

  return (
    <div>
      <div>
        {showTick && (
          <div className="tick-icon">
            <IoCheckmarkDoneSharp
              style={{
                fontSize: '80px',
                color: 'white',
                background: 'green',
                borderRadius: '50%',
                padding: '10',
              }}
            />
            {division}
          </div>
        )}
        <Divider />
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Party Code</th>
              <th>Product Name</th>
              <th>Batch Number</th>
              <th>MRP</th>
              <th>Expiry Date</th>
              <th>Mfg Date</th>
              <th>Division</th>
              <th>Category</th>
              <th>Quantities</th>
              {sessionStorage.getItem("reportType") === "sun-online" && (
                <th>Verdict</th>
              )}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {records.map((item, index) => {
              console.log('Item for row', item)
              return (
                <Row
                  item={item}
                  index={index}
                  key={index}
                  // reload={loadTodaysReport}
                  setRecords={setRecords}
                />
              )
            })}
          </tbody>
          {records?.length > 0 ? (
            <tfoot>
              <tr>
                <th colSpan={9}></th>
                <th style={{ textAlign: 'center' }}>TOTAL QTY </th>
                <th style={{ textAlign: 'center' }}>
                  {records.reduce((total, item) => total + item.quantity, 0)}
                </th>
                <th></th>
              </tr>
            </tfoot>
          ) : (
            <></>
          )}
        </table>
      </div>
    </div>
  )
}

export default TodaysReport

function showCategoryPopup(options) {
  return new Promise((resolve) => {
    const container = document.createElement('div')
    document.body.appendChild(container)
    const root = ReactDOM.createRoot(container)

    const Popup = () => {
      const [selectedIndex, setSelectedIndex] = React.useState(0)

      const cleanup = () => {
        root.unmount()
        container.remove()
      }

      const handleConfirm = (index) => {
        const selectedValue = options[index]
        cleanup()
        resolve(selectedValue)
      }

      React.useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.key === 'ArrowDown') {
            setSelectedIndex((prev) => (prev + 1) % options.length)
            e.preventDefault()
          } else if (e.key === 'ArrowUp') {
            setSelectedIndex(
              (prev) => (prev - 1 + options.length) % options.length
            )
            e.preventDefault()
          } else if (e.key === 'Enter') {
            handleConfirm(selectedIndex)
            e.preventDefault()
          } else if (/^[1-9]$/.test(e.key)) {
            const idx = parseInt(e.key, 10) - 1
            if (idx < options.length) handleConfirm(idx)
          } else if (e.key === 'Escape') {
            cleanup()
            resolve(null)
          }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
      }, [selectedIndex])

      return (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.4)',
            zIndex: 9998,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
              minWidth: '300px',
              zIndex: 9999,
            }}
          >
            <h3>Select Category</h3>
            <div style={{ margin: '10px 0' }}>
              {options.map((opt, idx) => (
                <div
                  key={opt}
                  style={{
                    marginBottom: '8px',
                    padding: '6px 10px',
                    borderRadius: '4px',
                    backgroundColor: selectedIndex === idx ? '#e9ecef' : '',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleConfirm(idx)}
                >
                  <input
                    type="radio"
                    id={opt}
                    name="popup-category"
                    value={opt}
                    checked={selectedIndex === idx}
                    onChange={() => setSelectedIndex(idx)}
                  />
                  <label htmlFor={opt} style={{ marginLeft: '8px' }}>
                    {opt}
                  </label>
                </div>
              ))}
            </div>
            <p style={{ fontSize: 12, color: '#666' }}>
              ↑ ↓ to navigate, Enter to confirm, 1–9 to choose, Esc to cancel
            </p>
          </div>
        </div>
      )
    }

    root.render(<Popup />)
  })
}
